import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// imports
import { useTranslation } from "react-i18next";
import { Form, Row, Col, Button } from "react-bootstrap";

// Import the API service
import { postData } from "../../Services/apiService";

// import the components
import { useAuth } from "../../Provider/Auth/AuthProvider";
import { useAlert } from "../../Provider/Alert/AlertContext";
import LogoPrimus from "../../Assets/Images/logo_primus.png";

// Import the CSS
import "./login.css";

export default function Login() {
    // Hook for the alert
    const { addAlert } = useAlert();

    // Hook for the navigation
    const navigate = useNavigate();

    // Hook for translation
    const { t, i18n } = useTranslation();
    useEffect(() => {
        const auth = JSON.parse(localStorage.getItem("auth"));
        if (auth) {
            navigate("/dashboard");
            return;
        }

        // Define a liguagem de acordo com o que está no localStorage
        i18n.changeLanguage(localStorage.getItem("language") || "pt-BR");

        // Define a tema de acordo com o que está no localStorage
        const theme = localStorage.getItem("theme");
        if (theme) {
            document.documentElement.setAttribute("data-bs-theme", theme);
        } else {
            document.documentElement.setAttribute("data-bs-theme", "light");
        }
    }, [i18n, navigate]);

    // Hook for the authentication
    const { login } = useAuth();

    // State for the user
    const [user, setUser] = useState({
        email: "",
        password: "",
    });

    // Valida os campos obrigatorios
    const [errors, setErrors] = useState({});
    const validateForm = () => {
        const newErrors = {};
        console.log(user);
        if (user.email === "")
            newErrors.email = t("login.error.email.required");
        if (!isValidEmail(user.email) && !newErrors.email)
            newErrors.email = t("login.error.email.invalid");
        if (user.password === "")
            newErrors.password = t("login.error.password.required");
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Function to handle the form submission
    const handleSubmit = async () => {
        // Valida o formulario
        if (validateForm()) {
            try {
                const submitLogin = await postData("/login", {
                    email: user.email,
                    password: user.password,
                });

                // Check the response status
                if (submitLogin.status === 200) {
                    // Save the token
                    login(submitLogin.body.data);
                    // Redirect to the home page
                    navigate("/dashboard");
                    return;
                }
                // Show the error message
                if (submitLogin.status === 401) {
                    addAlert(
                        "danger",
                        t("login.title"),
                        t("login.error.invalidPassword")
                    );
                    return;
                }
                if (submitLogin.status === 404) {
                    addAlert(
                        "danger",
                        t("login.title"),
                        t("login.error.userNotFound")
                    );
                }
            } catch (error) {
                // Show the error message
                console.log(error);
            }
        }
    };

    // Return the component
    return (
        <Row className="login">
            <Col md={3} className="login-container">
                <h2>{t("login.title")}</h2>
                <Form>
                    <Form.Label>{t("login.email")}</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="name@example.com"
                        onChange={(e) =>
                            setUser({ ...user, email: e.target.value })
                        }
                        isInvalid={!!errors.email}
                        className="mb-3"
                    />
                    <Form.Label>{t("login.password")}</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Password"
                        onChange={(e) => {
                            setUser({ ...user, password: e.target.value });
                        }}
                        isInvalid={!!errors.password}
                        className="mb-3"
                    />
                    <Form.Text className="text-muted">
                        <a href="/forgot-password">{t("login.forgot")}</a>
                        <br />
                    </Form.Text>

                    <Button variant="primary" onClick={handleSubmit}>
                        {t("login.button")}
                    </Button>
                </Form>
            </Col>
            <Col className="login-image">
                <img src={LogoPrimus} alt="Logo Primus" />
            </Col>
        </Row>
    );
}

function isValidEmail(email) {
    // Expressão regular para validar email
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
}
